import { render, staticRenderFns } from "./TermsAndConditionsTab.vue?vue&type=template&id=6e47f78c"
import script from "./TermsAndConditionsTab.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports